import { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { NoSuggestionsTextField } from "../../../../components/textFields";
import BackgroundImageSelectionDialog from "../image_components/background_image_selection_dialog";

function CreateSection({ nameSection, setNameSection, setImageSection, restaurantId, setImageIdSection }) {
  const [selectedImageUrl, setSelectedImageUrl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const handleImageSelect = (image) => {
    setSelectedImageUrl(image.image_url);
    setImageSection(image.image_url);
    setImageIdSection(image.image_id)
    setOpenDialog(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: 2,
      }}
    >
      {/* Campo de Nombre de la Sección */}
      <NoSuggestionsTextField
        autoFocus
        required
        margin="dense"
        id="name"
        name="name"
        label="Nombre de la Sección"
        type="text"
        fullWidth
        onChange={(e) => setNameSection(e.target.value)}
        value={nameSection}
      />

      {/* Selección de Imagen */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {selectedImageUrl && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              p: 1,
              bgcolor: "#f9f9f9",
              borderRadius: "10px",
              border: "1px dashed #e0e0e0"
            }}
          >
            <Typography variant="caption" display="block" color="textSecondary" sx={{ mb: 1 }}>
              Imagen seleccionada
            </Typography>
            <Box
              component="img"
              src={selectedImageUrl}
              alt="Preview"
              sx={{
                maxWidth: "100%",
                maxHeight: "180px",
                borderRadius: "8px",
                objectFit: "contain",
              }}
            />
          </Box>
        )}

        <Button
          onClick={() => setOpenDialog(true)}
          fullWidth
          sx={{
            background: "#ff3b3b",
            color: "#FFF",
            padding: "12px",
            "&:hover": {
              color: "#111",
            },
          }}
        >
          {selectedImageUrl ? "Cambiar Imagen" : "Seleccionar Imagen"}
        </Button>
      </Box>

      {/* Dialog de selección de imagen */}
      <BackgroundImageSelectionDialog
        open={openDialog}
        handleClose={() => setOpenDialog(false)}
        restaurantId={restaurantId}
        onSelectImage={handleImageSelect}
      />
    </Box>
  );
}

export default CreateSection;
